import React, { useState } from 'react';
import { RequetesAnalytics } from './RequetesAnalytics';
import { RequetesGerer } from './RequetesGerer';
import { RequetesConfigurer } from './RequetesConfigurer';
import { useLanguage } from '../contexts/LanguageContext';
import { useScreenInit } from '../useScreenInit.js';
export function RequetesModule() {
  const {
    t
  } = useLanguage();
  const screenInit = useScreenInit();
  const [activeSubTab, setActiveSubTab] = useState(screenInit.activeSubTab ?? 'gerer');
  const tabs: {
    id: string;
    label: string;
  }[] = [{
    id: 'gerer',
    label: t('Gérer', 'Manage')
  }, {
    id: 'analytiques',
    label: t('Analytiques', 'Analytics')
  }, {
    id: 'configurer',
    label: t('Configurer', 'Configure')
  }];
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-6121" data-mp="29nzv88rydy0k">
      {/* Page Title & Navigation */}
      <div className="mb-8" data-id="element-6122" data-mp="2ol8nr5szt7tv">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6" data-id="element-6123" data-mp="2oicpthh5aj5f">
          <h1 className="text-2xl font-bold text-[#0F172A] font-heading" data-id="element-6124" data-mp="2jjt4njadlbe4">
            {activeSubTab === 'analytiques' ? t('Tableau de bord des requêtes', 'Requests dashboard') : t('Requêtes', 'Requests')}
          </h1>
          <nav aria-label={t('Actions', 'Actions')} className="flex items-center gap-2" data-id="element-6125" data-mp="gyod1m5wi44w">
            {tabs.map(tab => <button key={tab.id} onClick={() => setActiveSubTab(tab.id)} className={`px-4 py-2 text-sm font-semibold rounded-lg transition-colors ${activeSubTab === tab.id ? 'text-white bg-[#0F172A] shadow-sm hover:bg-[#1E293B]' : 'text-slate-600 bg-white border border-slate-200 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-6126" data-mp="m040fkvjwmqg">
                {tab.label}
              </button>)}
          </nav>
        </div>
      </div>

      {activeSubTab === 'analytiques' ? <RequetesAnalytics onOpenRequests={() => setActiveSubTab('gerer')} data-id="element-6127" data-mp="1en8ba6hbrva5" /> : activeSubTab === 'configurer' ? <RequetesConfigurer data-id="element-6128" data-mp="3apux3yvvukzl" /> : <RequetesGerer data-id="element-6129" data-mp="3aqw70015x1fq" />}
    </div>;
}